module.exports = __webpack_public_path__ + "img/avatar5.ae153968.png";